__turbopack_context__.v({
  "close-label": "shippable-only-module-scss-module__F0PzvG__close-label",
});
